import React, { Fragment, useState, useEffect } from 'react';
import { Link, useHistory, useParams } from 'react-router-dom';
import { postData, fetchData } from '../../../apiService';
import Select from 'react-select'; // Import react-select
import TableContainer from '@mui/material/TableContainer';
import Paper from '@mui/material/Paper';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import DoneIcon from '@mui/icons-material/Done';
import CloseIcon from '@mui/icons-material/Close';
import AsyncSelect from 'react-select/async';

const SalaryAdvanceDetails = ({ match }) => {
    const [isLoading, setIsLoading] = useState(false);
    const history = useHistory();
    const { id } = useParams();
    const { isAuthenticated, companyId, branchId, userId, logout, token } = useAuth();

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }
    }, [isAuthenticated, companyId, branchId, token, logout]);

    const [errorMessage, setErrorMessage] = useState('');

    const [formData, setFormData] = useState({
        CompanyId: companyId,
        CreatedBy: userId,
        isSubmit: false,
        AdvanceAmount: 0,
        SplitAmount: 0,
        RepaymentDays: 0,
    });


    const [isFullScreen, setIsFullScreen] = useState(false);
    useEffect(() => {
        function handleResize() {
            setIsFullScreen(window.innerWidth >= 768); // Assuming full screen width is 768px or larger, adjust as needed
        }
        window.addEventListener('resize', handleResize);
        handleResize(); // Initial check
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    // Add a function to format the date
    const formatDateForInput = (dateString) => {
        const currentDate = new Date(dateString);;
        const year = currentDate.getFullYear();
        const month = String(currentDate.getMonth() + 1).padStart(2, '0');
        const day = String(currentDate.getDate()).padStart(2, '0');
        const formattedDate = `${year}-${month}-${day}`;
        return formattedDate;
    };

    useEffect(() => {
        fetchData('SalaryAdvanceApi', `/EmployeeAdvance/${id}`, token)
            .then((response) => {
                console.log('API response:', response);
                if (response.responseCode === '1111') {
                    setFormData(response.response_data);
                }
            })
            .catch((error) => {
                console.error('Error fetching data:', error);
            });
    }, [id, userId, token]);


    return (
        <div className="w-full container mx-auto mt-1" style={{ maxWidth: "100%" }}>
            {/* Header Section */}
            <div className="flex justify-between items-center bg-white rounded-xl shadow-sm border border-gray-200 px-2 py-2 mb-5">
                <h6
                    className="uppercase tracking-wide font-serif text-black mt-2 text-gray-700 flex-grow"
                    style={{ fontSize: "14px", fontWeight: "500" }}
                >
                    Salary Advance Details
                </h6>

                <div className="flex items-center space-x-2">
                    {/* Back to List Button */}
                    <Button
                        variant="contained"
                        color="error"
                        component={Link}
                        to={{
                            pathname: "/SalaryAdvanceIndex",
                            state: { from: "/SalaryAdvanceDetails" },
                        }}
                        onClick={() => {
                            localStorage.setItem("shouldReload", "true");
                        }}
                        style={{ height: "25px", borderRadius: "10px", marginRight: "5px", marginLeft: "5px" }}
                    >
                        Back To List
                    </Button>

                </div>
            </div>

            {errorMessage && (
                <p className="text-red-600 text-sm mb-4 text-center font-medium">
                    {errorMessage}
                </p>
            )}

            {/* Form Card */}
            <div className="bg-white rounded-xl shadow-md border border-gray-200 p-2" style={{ marginTop: '-30px' }}>
                {/* Row 1 */}
                <div className="grid grid-cols-6 gap-1 mb-3">
                    <div className="col-span-2">
                        <label className="text-xs uppercase mb-1 block">
                            Employee Name <span className="text-red-500">*</span>
                        </label>
                        <input
                            type="text"
                            name="EmployeeName"
                            value={formData.EmployeeName || ""}
                            className="border border-gray-300 rounded-lg px-3 py-2 w-full text-sm bg-gray-50"
                            style={{ height: '33px' }}
                            readOnly
                        />
                    </div>

                    <div>
                        <label className="text-xs uppercase mb-1 block">Advance Date <span className="text-red-500">*</span></label>
                        <input
                            type="date"
                            name="AdvanceDate"
                            value={formatDateForInput(formData.AdvanceDate)}
                            className="border border-gray-300 rounded-lg px-3 py-2 w-full text-sm focus:ring-2 focus:ring-blue-500 focus:outline-none"
                            style={{ height: '33px' }}
                            readOnly
                        />
                    </div>

                    <div>
                        <label className="text-xs uppercase mb-1 block">
                            Repayment Months <span className="text-red-500">*</span>
                        </label>
                        <input
                            type="number"
                            name="RepaymentDays"
                            value={formData.RepaymentDays || ""}
                            className="border border-gray-300 rounded-lg px-3 py-2 w-full text-sm bg-gray-50"
                            style={{ height: '33px', textAlign: 'right' }}
                            readOnly
                        />
                    </div>

                    <div>
                        <label className="text-xs uppercase mb-1 block">
                            Repayment Start Date
                        </label>
                        <input
                            type="date"
                            name="RepaymentStartDate"
                            value={formatDateForInput(formData.RepaymentStartDate)}
                            className="border border-gray-300 rounded-lg px-3 py-2 w-full text-sm focus:ring-2 focus:ring-blue-500 focus:outline-none"
                            style={{ height: '33px' }}
                            readOnly
                        />
                    </div>

                    <div>
                        <label className="text-xs uppercase mb-1 block">
                            Repayment End Date
                        </label>
                        <input
                            type="date"
                            name="RepaymentEndDate"
                            value={formatDateForInput(formData.RepaymentEndDate)}
                            className="border border-gray-300 rounded-lg px-3 py-2 w-full text-sm focus:ring-2 focus:ring-blue-500 focus:outline-none"
                            style={{ height: '33px' }}
                            readOnly
                        />
                    </div>
                </div>

                {/* Row 2 */}
                <div className="grid grid-cols-7 gap-2">
                    {/* Remarks - wider */}
                    <div className="col-span-5">
                        <label className="text-xs uppercase mb-1 block">Remarks</label>
                        <input
                            type="text"
                            name="Remarks"
                            value={formData.Remarks}
                            placeholder="Remarks"
                            className="border border-gray-300 rounded-lg px-3 py-2 w-full text-sm focus:ring-2 focus:ring-blue-500 focus:outline-none"
                            style={{ height: '33px' }}
                            readOnly
                        />
                    </div>

                    {/* Amount - smaller */}
                    <div className="col-span-1">
                        <label className="text-xs uppercase mb-1 block">
                            Amount <span className="text-red-500">*</span>
                        </label>
                        <input
                            type="number"
                            name="AdvanceAmount"
                            value={formData.AdvanceAmount || "0"}
                            placeholder="AdvanceAmount"
                            className="border border-gray-300 rounded-lg px-3 py-2 w-full text-sm text-right font-semibold focus:ring-2 focus:ring-blue-500 focus:outline-none"
                            style={{ height: '33px' }}
                            readOnly
                        />
                    </div>

                    {/* Split Amount - smaller */}
                    <div className="col-span-1">
                        <label className="text-xs uppercase mb-1 block">
                            Split Amount <span className="text-red-500">*</span>
                        </label>
                        <input
                            type="number"
                            name="SplitAmount"
                            value={formData.SplitAmount || "0"}
                            placeholder="Split Amount"
                            readOnly
                            className="border border-gray-300 rounded-lg px-3 py-2 w-full text-sm text-right font-semibold bg-gray-50"
                            style={{ height: '33px' }}
                        />
                    </div>
                </div>

            </div>
        </div>
    );


}

export default SalaryAdvanceDetails;
